import { HttpStatus } from '../types';
import { AppError, ErrorTypes } from './app.error';

export class BadRequestError extends AppError {
    constructor(detail?: string, rest?: { [key: string]: unknown }) {
        super({
            status: HttpStatus.BAD_REQUEST,
            type: ErrorTypes.INVALID_INPUT,
            title: 'Bad Request',
            detail,
            ...rest,
        });
    }
}
